import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

interface AProps extends React.LinkHTMLAttributes<HTMLLinkElement> {
  href: string;
}

export type GenericButtonProps = ButtonProps | LinkProps | AProps;

export const GenericButton = (props: GenericButtonProps) => {
  let ButtonComp: any = 'button';
  if ('to' in props) {
    ButtonComp = (lprops: any) => <Link to={props.to} {...lprops} />;
  }
  if ('href' in props) {
    ButtonComp = 'a';
  }

  return <ButtonComp {...props} />;
};
